/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Preview_Download_FailedInputs */

const en_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to download thumbnail: ${i?.error}`)
};

const fr_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec du telechargement de la miniature : ${i?.error}`)
};

const de_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download des Vorschaubildes fehlgeschlagen: ${i?.error}`)
};

const it_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile scaricare la miniatura: ${i?.error}`)
};

const ru_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить миниатюру: ${i?.error}`)
};

const es_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo descargar la miniatura: ${i?.error}`)
};

const zh_cn2_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`缩略图下载失败：${i?.error}`)
};

const ja_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サムネイルのダウンロードに失敗しました: ${i?.error}`)
};

const hi_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`थंबनेल डाउनलोड करने में विफल: ${i?.error}`)
};

const pt_pt2_video_export_preview_download_failed = /** @type {(inputs: Video_Export_Preview_Download_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao baixar a miniatura: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to download thumbnail: {error}" |
*
* @param {Video_Export_Preview_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_download_failed = /** @type {((inputs: Video_Export_Preview_Download_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Download_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_download_failed(inputs)
	if (locale === "de") return de_video_export_preview_download_failed(inputs)
	if (locale === "it") return it_video_export_preview_download_failed(inputs)
	if (locale === "ru") return ru_video_export_preview_download_failed(inputs)
	if (locale === "es") return es_video_export_preview_download_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_download_failed(inputs)
	if (locale === "ja") return ja_video_export_preview_download_failed(inputs)
	if (locale === "hi") return hi_video_export_preview_download_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_download_failed(inputs)
	return en_video_export_preview_download_failed(inputs)
});